import { ReactNode } from 'react'

/**
 * Tonos semánticos → colores del kit. Las vistas dicen qué significa el estado
 * ("exito", "error"); el color lo decide este mapa, no la página.
 *
 * `aviso` (algo pendiente, no un error) no existe en el kit, que no trae badge
 * amarillo: es `.badge--aviso` en styles/app.css, con --dcc-warning-bg/-strong.
 */
export type Tono = 'neutro' | 'info' | 'exito' | 'error' | 'marca' | 'aviso'
const CLASE: Record<Tono, string> = {
  neutro: 'dcc-badge--soft-default',
  info: 'dcc-badge--soft-lightblue',
  exito: 'dcc-badge--soft-green',
  error: 'dcc-badge--soft-red',
  marca: 'dcc-badge--soft-blue',
  aviso: 'badge--aviso',
}

/** Badge del kit en su variante suave, con punto de estado opcional. */
export function Badge({ tono = 'neutro', punto = false, children }: { tono?: Tono; punto?: boolean; children: ReactNode }) {
  return (
    <span className={`dcc-badge ${CLASE[tono]}`}>
      {punto && <span className="dcc-dot" aria-hidden />}
      {children}
    </span>
  )
}
